import { BRONZE, GREEN, RED } from "@/css/constants";

export function formatTime(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
}

export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function getRankIcon(rank: string) {
  switch (rank) {
    case "Bronze":
      return "error";
    case "Silver":
      return "error";
    case "Gold":
      return "tick-circle";
    default:
      return "error";
  }
}

export function getRankColor(rank: string) {
  switch (rank) {
    case "Bronze":
      return RED;
    case "Silver":
      return BRONZE;
    case "Gold":
      return GREEN;
    default:
      return BRONZE;
  }
}
